import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'

import CaseStudiesSalesContent from './../components/CaseStudies/CaseStudiesSalesContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/language/selector';

const CaseStudiesSales = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-sales-page.case-studies-sales-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesSalesContent/>
    </>
  )
}

export default CaseStudiesSales